import model from "../../model"
import axios from "../axios"

export const readInstitute = async (name) => {
    let res = await axios.get(`/institutes/${name}`)
    return model.fromInstituteDTO(res.data)
}

export const readInstitutesLocations = async (name) => {
    let res = await axios.get(`/institutes/${name}/locations`)
    return res.data ? model.fromLocationsDTO(res.data) : null
}

export const createInstituteLocation = async (name, createLocation) => {
    let locationDTO = model.toLocationDTO(createLocation)
    let res = await axios.post(`/institutes/${name}/locations`, locationDTO)
    return model.fromLocationDTO(res.data)
}

export const updateInstitute = async (name, institute) => {
    let instituteDTO = model.toInstituteDTO(institute)
    await axios.put(`/institutes/${name}`, instituteDTO)
    return {}
}

export const updateInstituteDefaultLocation = async (instituteName, locationId) => {
    let res = await axios.post(`/institutes/${instituteName}/makedefault/${locationId}`)
    return res
}